module.exports = __webpack_public_path__ + "static/media/clock.f2585f92.jpg";